//
//
//
//
//
//
//
//
//
//
//
//
//

import Add from "@/components/RegionAccount/Add";
export default {
  name: "AddProvince",
  components: { Add },
  data() {
    return {
      accountType: "province",
    };
  },
};
